import script from "./WCWebAdsModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCWebAdsModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCWebAdsModern.vue?vue&type=style&index=0&id=4b43a520&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b43a520"]])

export default __exports__